import React, { useState } from 'react';
import PasswordEditForm from './PasswordEditForm.js';
import EmailEditForm from './EmailEditForm.js';

const formatName = (value = '') => {
    if (!value) {
        return '';
    }

    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};

const ProfileTab = ({ data }) => {
    const [error, setError] = useState('');
    const [isEditingPw, setIsEditingPw] = useState(false);
    const [isEditingData, setIsEditingData] = useState(false);
    const [isEditingEmail, setIsEditingEmail] = useState(false);
    const [loading, setLoading] = useState(false);

    const [userData, setUserData] = useState({
        firstName: formatName(data?.Name),
        lastName: formatName(data?.SecondName),
    });
    const [firstName, setFirstName] = useState(formatName(data?.Name));
    const [lastName, setLastName] = useState(formatName(data?.SecondName));

    const setAllEditing = (isAllEditing) => {
        setIsEditingPw(isAllEditing);
        setIsEditingData(isAllEditing);
        setIsEditingEmail(isAllEditing);
    };

    const handleLogOut = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch('/Authorization/Logout', {
                method: 'POST',
            });

            if (response.ok) {
                window.location.href = '/Home';
            }
        } catch (err) {
        }
    };

    const handleDataSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await fetch('/Account/Save', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name: firstName, secondName: lastName }),
            });
            const responseData = await response.json();

            if (responseData.success) {
                setUserData({ firstName, lastName });
                setIsEditingData(false);
            } else {
                setError(responseData.message || 'Произошла ошибка');
            }
        } catch (err) {
            setError('Ошибка сети');
        }

        setLoading(false);
    };

    const cancelDataChange = (e) => {
        e.preventDefault();
        setFirstName(userData.firstName);
        setLastName(userData.lastName);
        setIsEditingData(false);
    };

    return (
        <section className="account-section">
            <div className="account-section__header">
                <h2 className="account-section__title">Личные данные и безопасность</h2>
                <p className="account-section__description">
                    Обновляйте имя, контролируйте подтверждение email и меняйте пароль в одном месте.
                </p>
            </div>

            <div className="account-stack">
                <EmailEditForm
                    data={data}
                    setAllEditing={setAllEditing}
                    isEditingEmail={isEditingEmail}
                    setIsEditingEmail={setIsEditingEmail}
                />

                <div className="account-panel">
                    <div className="account-panel__header">
                        <div>
                            <h3 className="account-panel__title">Персональные данные</h3>
                            <p className="account-panel__subtitle">Имя и фамилия, которые будут использоваться в заказах.</p>
                        </div>
                    </div>

                    {isEditingData ? (
                        <form onSubmit={handleDataSubmit} className="account-form">
                            <div className="account-form__grid">
                                <div className="account-field">
                                    <label className="account-field__label" htmlFor="account-first-name">
                                        Имя
                                    </label>
                                    <input
                                        id="account-first-name"
                                        type="text"
                                        name="firstName"
                                        value={firstName}
                                        onChange={(e) => setFirstName(formatName(e.target.value))}
                                        placeholder="Имя"
                                        className="account-input"
                                    />
                                </div>

                                <div className="account-field">
                                    <label className="account-field__label" htmlFor="account-last-name">
                                        Фамилия
                                    </label>
                                    <input
                                        id="account-last-name"
                                        type="text"
                                        name="lastName"
                                        value={lastName}
                                        onChange={(e) => setLastName(formatName(e.target.value))}
                                        placeholder="Фамилия"
                                        className="account-input"
                                    />
                                </div>
                            </div>

                            {error && <p className="account-error">{error}</p>}

                            <div className="account-actions">
                                <button type="submit" className="account-button" disabled={loading}>
                                    {loading ? 'Загрузка...' : 'Сохранить'}
                                </button>
                                <button className="account-button--ghost" onClick={cancelDataChange} type="button">
                                    Отмена
                                </button>
                            </div>
                        </form>
                    ) : (
                        <div className="account-meta-list">
                            <div className="account-meta-row">
                                <span className="account-meta-label">Имя</span>
                                <span className="account-meta-value">{userData.firstName || 'Не указано'}</span>
                            </div>
                            <div className="account-meta-row">
                                <span className="account-meta-label">Фамилия</span>
                                <span className="account-meta-value">{userData.lastName || 'Не указано'}</span>
                            </div>
                            <div className="account-actions">
                                <button
                                    onClick={() => {
                                        setAllEditing(false);
                                        setIsEditingData(true);
                                    }}
                                    className="account-button--ghost"
                                    type="button"
                                >
                                    Изменить
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                <PasswordEditForm setAllEditing={setAllEditing} isEditingPw={isEditingPw} setIsEditingPw={setIsEditingPw} />

                <div className="account-actions">
                    <button onClick={handleLogOut} className="account-button--dark" type="button">
                        Выйти
                    </button>
                </div>
            </div>
        </section>
    );
};

export default ProfileTab;
